import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  toolbar: theme.mixins.toolbar,
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(720 + theme.spacing(2) * 2)]: {
      width: 720,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(6),
    padding: theme.spacing(4),
    backgroundColor: 'var(--color-white)',
    borderRadius: '28px !important',
    boxShadow: '0 22px 60px rgba(61, 30, 92, 0.10) !important',
    border: '1px solid rgba(61, 30, 92, 0.05)',
    '& h1': {
      fontFamily: 'Fraunces, serif',
      fontWeight: 700,
      color: 'var(--color-plum)',
      letterSpacing: '-0.015em',
      margin: '0 0 0.5rem',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2.5),
      marginTop: 16,
      borderRadius: '20px !important',
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 4),
    backgroundColor: 'transparent',
    '& .MuiStepLabel-label': {
      fontFamily: 'Inter, sans-serif',
      fontSize: '0.85rem',
      fontWeight: 500,
      color: 'var(--color-text-soft)',
      '&.MuiStepLabel-active': {
        color: 'var(--color-coral)',
        fontWeight: 700,
      },
      '&.MuiStepLabel-completed': {
        color: 'var(--color-plum)',
      },
    },
    '& .MuiStepIcon-root': {
      color: 'var(--color-medium-grey)',
      width: '1.7rem',
      height: '1.7rem',
      '& text': {
        fill: 'var(--color-white)',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 700,
      },
    },
    '& .MuiStepIcon-active': {
      color: 'var(--color-coral) !important',
    },
    '& .MuiStepIcon-completed': {
      color: 'var(--color-coral-deep) !important',
    },
    '& .MuiStepConnector-line': {
      borderColor: 'rgba(61, 30, 92, 0.12)',
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
    gap: theme.spacing(1),
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  divider: {
    margin: '20px 0',
    backgroundColor: 'rgba(61, 30, 92, 0.08)',
  },
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
